module.exports = __webpack_public_path__ + "static/5-cb4f5c257249d33af2b79888e668715e.jpg";